import { render, staticRenderFns } from "./inviteOpenUserAndAccount.vue?vue&type=template&id=35930c22&scoped=true"
import script from "./inviteOpenUserAndAccount.vue?vue&type=script&lang=js"
export * from "./inviteOpenUserAndAccount.vue?vue&type=script&lang=js"
import style0 from "./inviteOpenUserAndAccount.vue?vue&type=style&index=0&id=35930c22&prod&lang=scss&scoped=true"
import style1 from "./inviteOpenUserAndAccount.vue?vue&type=style&index=1&id=35930c22&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35930c22",
  null
  
)

export default component.exports